import React, { useRef } from "react";
import { Link } from "react-router-dom";
import "./Music.css";
import useTrackPreviews from "../hooks/UseTrackPreviews";
import { useReleases } from "../contexts/MusicContext";
import BackToHomeLink from "../components/BackToHomeLink";

function Music() {
  const { releases, loading, error } = useReleases();
  const releasesWithPreview = useTrackPreviews(releases);

  const currentAudio = useRef(null); // To keep track of the currently playing audio

  const handlePlay = (e) => {
    if (currentAudio.current && currentAudio.current !== e.target) {
      currentAudio.current.pause(); // Pause the previously playing audio
    }
    currentAudio.current = e.target; // Set the current audio
  };

  const uniqueAlbums = new Set();

  if (loading) {
    return (
      <div>
        <BackToHomeLink />
        <p>Loading discography...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <BackToHomeLink />
        <p>Something went wrong. Could not fetch discography.</p>
      </div>
    );
  }

  if (!releases || releases.length === 0) {
    return (
      <div>
        <BackToHomeLink />
        <p>No releases found.</p>
      </div>
    );
  }

  return (
    <div>
      <BackToHomeLink />
      <h1>Music</h1>
      <h3>
        Projects that I have worked on, whether that be performing, writing,
        recording, producing, mixing, and/or mastering
      </h3>
      <div className="image-grid">
        {releasesWithPreview.map((release, index) => {
          // Check if the album is already displayed
          if (uniqueAlbums.has(release.album_name)) {
            return null; // Skip displaying duplicate albums
          }
          uniqueAlbums.add(release.album_name); // Add to the set of displayed albums

          return (
            <div key={index} className="release-item">
              <div className="image-container">
                {release.is_album ? (
                  <Link to={`/music/${release.album_name}`}>
                    <img
                      className="release-image"
                      src={release.artwork_url}
                      alt={release.album_name}
                    />
                  </Link>
                ) : (
                  <img
                    className="release-image"
                    src={release.artwork_url}
                    alt="Not available"
                  />
                )}
                <div className="release-info">
                  {release.is_album ? (
                    <pb>{release.album_name}</pb>
                  ) : (
                    <pb>{release.song_name}</pb>
                  )}
                  <p className="italic">{release.artist_name}</p>
                  {!release.is_album ? (
                    release.track_preview === "no_preview_available" ? (
                      <p>Preview not available</p>
                    ) : release.track_preview ? (
                      <audio
                        key={release.track_preview} // forces remount when URL changes
                        controls
                        onPlay={handlePlay}
                      >
                        <source src={release.track_preview} type="audio/mpeg" />
                      </audio>
                    ) : (
                      <p>Preview loading...</p>
                    )
                  ) : (
                    <div>Click artwork to see album</div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Music;
